import React from "react";
import LegalPage from "../components/LegalPage";
export default function Terms() {
  return <LegalPage tKey="terms" testid="terms-page" />;
}
